import React, { createContext, useContext, useState, useCallback } from "react";

const AssessmentContext = createContext(null);

export const AssessmentProvider = ({ children }) => {
  const [userInfo, setUserInfo] = useState(null);
  const [answers, setAnswers] = useState({});
  const [obiettivo, setObiettivo] = useState("");
  const [result, setResult] = useState(null);

  const reset = useCallback(() => {
    setUserInfo(null);
    setAnswers({});
    setObiettivo("");
    setResult(null);
  }, []);

  const value = {
    userInfo,
    setUserInfo,
    answers,
    setAnswers,
    obiettivo,
    setObiettivo,
    result,
    setResult,
    reset,
  };

  return <AssessmentContext.Provider value={value}>{children}</AssessmentContext.Provider>;
};

export const useAssessment = () => {
  const ctx = useContext(AssessmentContext);
  if (!ctx) throw new Error("useAssessment must be used within AssessmentProvider");
  return ctx;
};
